import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Printer, Barcode, QrCode } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const barcodeUrl = (code, fmt) => `${BACKEND}/api/barcode/${encodeURIComponent(code)}${fmt === 'qr' ? '?fmt=qr' : ''}`;

// Printable barcode/QR label for a platform SKU or seller/store code.
export const BarcodeLabelDialog = ({ code, title = '', subtitle = '', onClose }) => {
  const [fmt, setFmt] = useState('code128');

  const print = () => {
    const w = window.open('', '_blank', 'width=420,height=320');
    if (!w) return;
    const safe = (s) => String(s || '').replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));
    w.document.write(`<!doctype html><html><head><title>Etiqueta ${safe(code)}</title>
      <style>@page{margin:6mm} body{font-family:Arial,Helvetica,sans-serif;text-align:center;padding:8px} .t{font-size:13px;font-weight:700;margin-bottom:2px} .s{font-size:11px;color:#555;margin-bottom:6px} img{max-width:100%;height:auto} .c{font-size:12px;letter-spacing:1px;margin-top:4px}</style>
      </head><body onload="window.print();setTimeout(()=>window.close(),300)">
      ${title ? `<div class="t">${safe(title)}</div>` : ''}
      ${subtitle ? `<div class="s">${safe(subtitle)}</div>` : ''}
      <img src="${barcodeUrl(code, fmt)}" alt="${safe(code)}"/>
      <div class="c">${safe(code)}</div>
      </body></html>`);
    w.document.close();
  };

  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="seller-dialog max-w-sm" data-testid="barcode-label-dialog">
        <DialogHeader>
          <DialogTitle>Etiqueta / código de barras</DialogTitle>
          <DialogDescription>Imprime una etiqueta con el código de la plataforma para estanterías o inventario.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <ToggleGroup type="single" value={fmt} onValueChange={(v) => v && setFmt(v)} data-testid="barcode-label-format">
            <ToggleGroupItem value="code128" data-testid="barcode-fmt-code128" aria-label="Código de barras"><Barcode className="h-4 w-4" /> Barras</ToggleGroupItem>
            <ToggleGroupItem value="qr" data-testid="barcode-fmt-qr" aria-label="Código QR"><QrCode className="h-4 w-4" /> QR</ToggleGroupItem>
          </ToggleGroup>
        </div>
        <div className="rounded-lg border border-border bg-white p-4 text-center">
          {title && <p className="font-bold text-sm text-black">{title}</p>}
          {subtitle && <p className="text-xs text-neutral-500 mb-2">{subtitle}</p>}
          <img src={barcodeUrl(code, fmt)} alt={code} className="mx-auto max-h-40 object-contain" data-testid="barcode-label-image" />
          <p className="mt-2 text-sm tracking-wider text-black" data-testid="barcode-label-code">{code}</p>
        </div>
        <DialogFooter>
          <Button variant="outline" data-testid="barcode-label-close" onClick={onClose}>Cerrar</Button>
          <Button className="seller-primary" data-testid="barcode-label-print" onClick={print}><Printer className="h-4 w-4" /> Imprimir</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
